import { useContext } from "react";
import { DataRow } from "../DataRow";
import { DataListRowContext } from "./DataListRowContext";
import { DataId } from "../DataId";

/**
 * Gets the current row and its index.
 * @returns The current row and index, if any.
 */
export function useDataListRow(): {row: DataRow<object> | null, id: DataId} {
  const { row, id } = useContext(DataListRowContext);
  return { row, id };
}
